module.exports = __webpack_public_path__ + "img/278.61991d16.jpg";